import LineGlassMartiniAltIcon from 'LuxKit/Icons/line/LineGlassMartiniAltIcon'
import LineGlobeAltIcon from 'LuxKit/Icons/line/LineGlobeAltIcon'
import LinePhoneIcon from 'LuxKit/Icons/line/LinePhoneIcon'
import LineRefundIcon from 'LuxKit/Icons/line/LineRefundIcon'
import LineStarIcon from 'LuxKit/Icons/line/LineStarIcon'
import LineTagAltIcon from 'LuxKit/Icons/line/LineTagAltIcon'
import type SvgIcon from 'LuxKit/SvgIcon'
import { NO_24_7_SUPPORT_REGIONS } from 'constants/config/region'
import { isNonNullable } from 'lib/array/arrayUtils'
import getIsLoyaltyEnabled from 'loyalty/selectors/getIsLoyaltyEnabled'
import { createSelector } from 'reselect'

interface USPContentItem {
  Icon: typeof SvgIcon
  body: string
}

const getUSPContent = createSelector(
  (state: App.State) => state.geo.currentRegionCode,
  (state: App.State) => getIsLoyaltyEnabled(state),
  (
    currentRegionCode,
    isLoyaltyEnabled,
  ): Array<USPContentItem> => {
    const no247Support = NO_24_7_SUPPORT_REGIONS.includes(currentRegionCode)

    return [
      isLoyaltyEnabled ? {
        Icon: LineStarIcon,
        body: 'Earn points on every booking and use them towards future escapes.',
      } : undefined,
      {
        Icon: LineTagAltIcon,
        body: 'Unlock exclusive offers you won\'t find elsewhere.',
      },
      {
        Icon: LineGlassMartiniAltIcon,
        body: 'Enjoy bonus handpicked inclusions, curated just for you',
      },
      {
        Icon: LineGlobeAltIcon,
        body: 'Discover thousands of flights, hotels, tours, cruises & more',
      },
      {
        Icon: LineRefundIcon,
        body: 'Flexible booking options for peace of mind',
      },
      !no247Support ? {
        Icon: LinePhoneIcon,
        body: 'Our customer service team is available 24/7',
      } : undefined,
      no247Support ? {
        Icon: LinePhoneIcon,
        body: 'Our customer service team is available 9am to 7pm every day',
      } : undefined,
    ].filter(isNonNullable)
  },
)

export default getUSPContent
